module.exports = __webpack_public_path__ + "h5/img/wxPay.414136e0.png";